import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/rooted";

export const TopNav = () => (
  <header
    data-testid="top-nav"
    className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-xl border-b border-[#f2ede6]/8"
  >
    <div className="max-w-6xl mx-auto px-6 md:px-10 h-16 md:h-18 flex items-center justify-between">
      <Link
        to="/"
        data-testid="nav-logo"
        className="flex items-center gap-3 group"
      >
        <img
          src={LOGO_URL}
          alt="Rooted"
          className="h-9 w-9 md:h-10 md:w-10 object-contain transition-transform duration-700 group-hover:scale-105"
        />
        <span className="font-display text-lg md:text-xl tracking-tight text-rooted">
          Rooted
        </span>
      </Link>

      <div className="flex items-center gap-5 md:gap-7">
        <Link
          to="/"
          data-testid="nav-home"
          className="font-display text-sm md:text-[15px] text-rooted/85 hover:text-[#39971a] transition-colors duration-300"
        >
          Home
        </Link>
        <a
          href="/#waitlist"
          data-testid="nav-join-waitlist"
          className="btn-pill text-sm md:text-[15px] px-5 md:px-6 py-2.5"
        >
          Join Waitlist
        </a>
      </div>
    </div>
  </header>
);

export default TopNav;
